export const MIN_RESERVATION_VESSEL_DIMENSION = 0.1;
export const MAX_RESERVATION_VESSEL_LOA = 250;
export const MAX_RESERVATION_VESSEL_BEAM = 40;
export const MAX_RESERVATION_VESSEL_DRAFT = 20;
